import React from 'react';

const EmptyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="106"
      height="100"
      viewBox="0 0 106 100"
      fill="none"
    >
      <path
        d="M45.1033 99.4921C69.737 99.4921 89.7066 95.7607 89.7066 91.1579C89.7066 86.555 69.737 82.8237 45.1033 82.8237C20.4696 82.8237 0.5 86.555 0.5 91.1579C0.5 95.7607 20.4696 99.4921 45.1033 99.4921Z"
        fill="#F5F5F7"
        fillOpacity="0.8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.7854 66.6737L65.0452 47.3019C64.29 46.3901 63.186 45.8381 62.0235 45.8381H28.1814C27.0196 45.8381 25.9156 46.3901 25.1604 47.3019L9.4209 66.6737V76.7941H80.786V66.6737H80.7854Z"
        fill="#AEB8C2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7566 20.8355H67.4493C68.1473 20.8355 68.8166 21.1128 69.3102 21.6063C69.8037 22.0998 70.0809 22.7692 70.0809 23.4671V84.8776C70.0809 85.5755 69.8037 86.2449 69.3102 86.7384C68.8166 87.2319 68.1473 87.5092 67.4493 87.5092H22.7566C22.0586 87.5092 21.3893 87.2319 20.8958 86.7384C20.4023 86.2449 20.125 85.5755 20.125 84.8776V23.4671C20.125 22.7692 20.4023 22.0998 20.8958 21.6063C21.3893 21.1128 22.0586 20.8355 22.7566 20.8355V20.8355Z"
        fill="#F5F5F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.5772 27.3835H61.6278C61.9768 27.3835 62.3115 27.5222 62.5582 27.7689C62.805 28.0157 62.9436 28.3504 62.9436 28.6993V45.1184C62.9436 45.4674 62.805 45.8021 62.5582 46.0488C62.3115 46.2956 61.9768 46.4342 61.6278 46.4342H28.5772C28.2282 46.4342 27.8935 46.2956 27.6468 46.0488C27.4 45.8021 27.2614 45.4674 27.2614 45.1184V28.6993C27.2614 28.3504 27.4 28.0157 27.6468 27.7689C27.8935 27.5222 28.2282 27.3835 28.5772 27.3835ZM28.7495 53.577H61.4555C61.8501 53.577 62.2287 53.7338 62.5077 54.0128C62.7868 54.2919 62.9436 54.6704 62.9436 55.0651C62.9436 55.4598 62.7868 55.8383 62.5077 56.1174C62.2287 56.3965 61.8501 56.5533 61.4555 56.5533H28.7495C28.3548 56.5533 27.9763 56.3965 27.6972 56.1174C27.4182 55.8383 27.2614 55.4598 27.2614 55.0651C27.2614 54.6704 27.4182 54.2919 27.6972 54.0128C27.9763 53.7338 28.3548 53.577 28.7495 53.577ZM28.7495 61.3158H61.4555C61.8502 61.3158 62.2288 61.4726 62.508 61.7518C62.7871 62.0309 62.9439 62.4095 62.9439 62.8043C62.9439 63.199 62.7871 63.5776 62.508 63.8568C62.2288 64.1359 61.8502 64.2928 61.4555 64.2928H28.7495C28.3548 64.2928 27.9762 64.1359 27.697 63.8568C27.4179 63.5776 27.261 63.199 27.261 62.8043C27.261 62.4095 27.4179 62.0309 27.697 61.7518C27.9762 61.4726 28.3548 61.3158 28.7495 61.3158ZM80.6397 89.9355C80.1298 91.9559 78.339 93.4618 76.2087 93.4618H13.9962C11.866 93.4618 10.0752 91.9553 9.56597 89.9355C9.46886 89.5505 9.4198 89.1549 9.41992 88.7579V66.6743H26.7344C28.6469 66.6743 30.1883 68.2849 30.1883 70.2401V70.2664C30.1883 72.221 31.7476 73.7993 33.6601 73.7993H56.5449C58.4574 73.7993 60.0166 72.2066 60.0166 70.2513V70.2434C60.0166 68.2881 61.5581 66.6737 63.4706 66.6737H80.7851V88.7585C80.7851 89.1645 80.7344 89.5585 80.6397 89.9355Z"
        fill="#DCE0E6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.8162 21.9026L78.3227 23.6461C78.2073 23.6909 78.0815 23.7023 77.9599 23.6789C77.8383 23.6555 77.7258 23.5982 77.6352 23.5137C77.5447 23.4292 77.4799 23.3208 77.4483 23.2011C77.4166 23.0813 77.4194 22.9551 77.4563 22.8368L78.7306 18.7533C77.0273 16.8164 76.0273 14.4546 76.0273 11.9059C76.0273 5.33026 82.6839 0 90.8958 0C99.1056 0 105.763 5.33026 105.763 11.9059C105.763 18.4816 99.1063 23.8118 90.8951 23.8118C87.9162 23.8118 85.1425 23.1105 82.8162 21.9026Z"
        fill="#DCE0E6"
      />
      <path
        d="M96.7523 14.0559C97.7874 14.0559 98.6266 13.2268 98.6266 12.204C98.6266 11.1811 97.7874 10.352 96.7523 10.352C95.7171 10.352 94.8779 11.1811 94.8779 12.204C94.8779 13.2268 95.7171 14.0559 96.7523 14.0559Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.9127 13.8243H83.1641L85.0706 10.5836L86.9127 13.8243ZM89.2555 10.5836H92.5351V13.8243H89.2555V10.5836Z"
        fill="white"
      />
    </svg>
  );
};

export default EmptyIcon;
